export const routes = [
  {
    path: "/bandCar",
    name: "BandCar",
    meta: {
      title: "绑定车辆",
    },
    component: () => import("@/views/bandCar.vue"),
  },
  {
    path: "/orderDetails",
    name: "OrderDetails",
    meta: {
      title: "订单详情",
    },
    component: () => import("@/views/orderDetails.vue"),
  },
  {
    path: "/orderList",
    name: "orderList",
    meta: {
      title: "明细",
    },
    component: () => import("@/views/orderList.vue"),
  },
  {
    path: "/orderSummary",
    name: "orderSummary",
    meta: {
      title: "统计",
    },
    component: () => import("@/views/orderSummary.vue"),
  },
  {
    path: "/plateList",
    name: "plateList",
    meta: {
      title: "车辆列表",
    },
    component: () => import("@/views/plateList.vue"),
  },
  {
    path: "/receiptPhoto",
    name: "receiptPhoto",
    meta: {
      title: "确认收货",
    },
    component: () => import("@/views/receiptPhoto.vue"),
  },
];
